import { Pager, QuotationTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1440. 見積タスク一覧
 * [GET] /workspaces/:identifier/quotation_tasks
 */
type Props = {
  identifier: string;
  page?: number;
  per?: number;
  quotation_task_phase_ids?: number[];
  user_ids?: number[];
  business_partner_ids?: number[];
  team_ids?: number[];
  subscribed?: boolean;
  sales_order_id?: number;
  archived?: boolean;
  enabled?: boolean;
};

export type QuotationTasksResponse = {
  quotation_tasks: QuotationTask[];
  pager: Pager;
}

const quotationTasks = (props: Props): Promise<QuotationTasksResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/quotation_tasks`, { params: props });
};

export const useQuotationTasks = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'quotation_tasks', { ...props }],
    queryFn: () => quotationTasks(props),
    enabled: props.enabled,
  });
};

export const useQuotationTasksInvalidate = (identifier: string) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', identifier, 'quotation_tasks'] });
  };

  return { invalidate };
};